module.exports = __webpack_public_path__ + "static/media/autre-am.ed123297.jpg";